import moment from 'moment';
import {
  PREFIX_DF,
  PREFIX_RH,
  PREFIX_T,
  PREFIX_WIND_MAG_KPH
} from '../shared/behaviour_models_utils';
import {calculateDIR} from '../shared/direction';
import {minZero} from '../../point_utils';

export {calculateDIR};

export function calculateFMC(wd) {
  const t = moment(wd.name, 'ddd DD/MM hh:mm A');
  const hr = t.hours();
  const relative_humidity = wd[PREFIX_RH];
  const air_temp = wd[PREFIX_T];

  if (typeof relative_humidity !== 'undefined' &&
      typeof air_temp !== 'undefined') {
    if (hr < 12) {
      return minZero(12.519 - (0.282 * air_temp) + (0.112 * relative_humidity));
    }
    return minZero(6.783 - (0.17 * air_temp) + (0.133 * relative_humidity));
  }
  return undefined;
}

export function calculateFMCForPrescription(wd) {
  const fmc = calculateFMC(wd);
  if (typeof fmc !== 'undefined') {
    return fmc.toFixed(1);
  }
  return undefined;
}

export function calculateFuelAvailabilityFactor(wd) {
  const drought_factor = wd[PREFIX_DF];
  if (typeof drought_factor !== 'undefined') {
    return drought_factor / 10.0;
  }
  return undefined;
}

export function calculateFROSFlat(wd, vars) {
  const fmc = calculateFMC(wd);
  const fuel_availability_factor = calculateFuelAvailabilityFactor(wd);
  const wind_speed = wd[PREFIX_WIND_MAG_KPH];
  if (typeof fmc !== 'undefined' &&
      typeof wind_speed !== 'undefined' &&
      typeof fuel_availability_factor !== 'undefined') {
    return (0.22 * vars.fine_fuel_load * Math.exp(0.158 * (1.674 + 0.179 * wind_speed) - 0.227 * fmc)) *
           fuel_availability_factor *
           60;
  }
  return undefined;
}

export function calculateFROS(wd, vars) {
  const fros_flat = calculateFROSFlat(wd, vars);
  if (typeof fros_flat !== 'undefined') {
    return fros_flat * Math.exp(0.0662 * vars.slope);
  }
  return undefined;
}

export function calculateFROS_NW(wd, vars) {
  const fmc = calculateFMC(wd);
  const fuel_availability_factor = calculateFuelAvailabilityFactor(wd);
  if (typeof fmc !== 'undefined' &&
      typeof fuel_availability_factor !== 'undefined') {
    return (0.22 * vars.fine_fuel_load * Math.exp(-0.227 * fmc)) * fuel_availability_factor * 60;
  }
  return undefined;
}

export function calculateFH(wd, vars) {
  const fros = calculateFROS(wd, vars);
  const fuel_availability_factor = calculateFuelAvailabilityFactor(wd);

  if (typeof fros !== 'undefined' &&
      typeof fuel_availability_factor !== 'undefined') {
    return minZero(0.3048 * 31.7537 * (1 - Math.exp(-0.31772 * fros / 18.3)) * (1 - Math.exp(
      -(0.03644 * Math.pow(1.1289, (fros / 18.3))) * (fuel_availability_factor * vars.fine_fuel_load / 2.2417))));
  }
  return undefined;
}

export function calculateSH(wd, vars) {
  const fros_flat = calculateFROSFlat(wd, vars);
  const air_temp = wd[PREFIX_T];
  if (typeof fros_flat !== 'undefined' &&
      typeof air_temp !== 'undefined') {
    if (air_temp < 20) {
      return minZero(-2.19 + (2.23 * Math.sqrt(fros_flat)));
    }
    return minZero(-0.296 + (2.23 * Math.sqrt(fros_flat)));
  }
  return undefined;
}

export function calculateFI(wd, vars) {
  const fros = calculateFROS(wd, vars);
  const fuel_availability_factor = calculateFuelAvailabilityFactor(wd);
  if (typeof fros !== 'undefined' &&
      typeof fuel_availability_factor !== 'undefined') {
    return 18000 * (fuel_availability_factor * vars.fine_fuel_load) * fros / 36000;
  }
  return undefined;
}



// WEBPACK FOOTER //
// ./src/utils/behaviour_models/leaflet_80/calculations.js